const FIRST_STEP = {
    type: 1,
    title: '选择 Excel',
}
const SECOND_STEP = {
    type: 2,
    title: '配置字段',
}
const LAST_STEP = {
    type: 3,
    title: '生成演示数据',
}
const STEP_OPTIONS = [FIRST_STEP, SECOND_STEP, LAST_STEP]

export {
    STEP_OPTIONS,
    FIRST_STEP,
    SECOND_STEP,
    LAST_STEP,
}
